import { z } from "zod";
import { safeFetch } from "../http/http";
import { requestor } from "../requestor";

const baseUrl = "https://workentityservice.design.vpsvc.com/api/v1/works";

const workSchema = z.object({
  workId: z.string(),
  design: z.object({
    designUrl: z.string().url(),
    displayUrl: z.string().url(),
  }),
  merchandising: z.object({
    merchandisingSelections: z.record(z.string(), z.string()),
    quantity: z.number(),
  }),
  product: z.object({
    key: z.string(),
    version: z.string(),
  }),
  ownerId: z.string().optional(),
});

export type Work = z.infer<typeof workSchema>;

export async function fetchWork(
  workId: string,
  authorizationHeader: string,
): Promise<Work> {
  return await safeFetch(workSchema, `${baseUrl}/${workId}?from=${requestor}`, {
    headers: { Authorization: authorizationHeader },
  });
}
